import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center">
      <img 
        src="/images/zwiftlabs-logo-transparent.png" 
        alt="ZWIFT LABS Logo" 
        className="h-16  w-auto ms-1"
        style={{ maxHeight: '100px' }}
      />
    </div>
  );
};

export default Logo;
